import React, { useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

// Public landing page the backend's /api/etsy/callback redirects to once it has
// already exchanged the code and saved the destination server-side. No auth
// required — this is the page a mobile Safari tab lands on after completing
// Etsy OAuth from the iOS app, so it can't assume a logged-in webapp session.
const EtsyOAuth = () => {
  const [status, setStatus] = useState('error'); // 'connected' | 'denied' | 'error'

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const etsyStatus = urlParams.get('etsy');
    setStatus(etsyStatus || 'error');

    if (etsyStatus === 'connected') {
      window.location.href = 'shopik://accountsettings/success';
      setTimeout(() => {
        window.location.href = '/settings';
      }, 1500);
    }
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
        textAlign: 'center',
        px: 3,
      }}
    >
      <img src="/images/logo.png" alt="Hemlock" style={{ maxWidth: '160px', marginBottom: 8 }} />

      {status === 'connected' && (
        <>
          <CheckCircleOutlineIcon sx={{ fontSize: 56, color: '#4751ed' }} />
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            Etsy account connected
          </Typography>
          <Typography variant="body1" color="text.secondary">
            You can close this window and return to the app.
          </Typography>
          <Button
            variant="text"
            href="/settings"
            sx={{ color: '#4751ed', textTransform: 'none', mt: 1 }}
          >
            Or click here to go to Settings
          </Button>
        </>
      )}

      {status === 'denied' && (
        <>
          <ErrorOutlineIcon sx={{ fontSize: 56, color: '#9e9e9e' }} />
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            Etsy authorization cancelled
          </Typography>
          <Typography variant="body1" color="text.secondary">
            You can close this window and return to the app.
          </Typography>
        </>
      )}

      {status === 'error' && (
        <>
          <ErrorOutlineIcon sx={{ fontSize: 56, color: '#d32f2f' }} />
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            Something went wrong
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 360 }}>
            We couldn't connect your Etsy account. Please try again.
          </Typography>
          <Button
            variant="contained"
            href="/settings"
            sx={{
              mt: 1,
              backgroundColor: '#4751ed',
              textTransform: 'none',
              ':hover': { backgroundColor: '#6133aa' },
            }}
          >
            Back to Settings
          </Button>
        </>
      )}
    </Box>
  );
};

export default EtsyOAuth;
